/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { personSummaryDataLastActivityActorTypeSchema } from './PersonSummaryDataLastActivityActorTypeSchema'
import { personSummaryDataLastActivityLabelSchema } from './PersonSummaryDataLastActivityLabelSchema'

export const personSummaryDataSchema = z.object({
	id: z.string(),
	name: z.string().nullable(),
	primaryEmail: z.string().nullable(),
	primaryPhone: z.string().nullable(),
	candidacyCount: z.number(),
	lastAppliedAt: z.iso.datetime().nullable(),
	lastActivityAt: z.iso.datetime().nullable(),
	lastActivityLabel: personSummaryDataLastActivityLabelSchema.nullable(),
	lastActivityCampaign: z.object({ id: z.string(), title: z.string() }).nullable(),
	lastActivityActorType: personSummaryDataLastActivityActorTypeSchema.nullable(),
	lastActivityActorName: z.string().nullable(),
	skills: z.array(
		z.object({
			escoSkillId: z.string(),
			conceptUri: z.string(),
			label: z.string(),
			sources: z.array(z.object({ candidateId: z.string(), questionId: z.string(), optionId: z.string() })),
		}),
	),
})

export type PersonSummaryDataSchema = z.infer<typeof personSummaryDataSchema>
